/** Estimation API — Faz 1.4 createApi factory ile yeniden yazıldı. Önce. */
import {createApi} from './_factory'
import type {EstimationNs} from '@shared/types'

const api = createApi('estimation')

export const EstimationApi = {
  // — Read —
  getEstimationData: (data: EstimationNs.GetFeatureEstimationsRequest) =>
    api.post<EstimationNs.GetFeatureEstimationsRequest, EstimationNs.FeatureEstimation[]>('features', data),
  getProjectEstimations: (data: EstimationNs.GetEstimationsRequest) =>
    api.post<EstimationNs.GetEstimationsRequest, EstimationNs.ProjectEstimation[]>('get', data),
  getGroupSummary: (data: EstimationNs.GetGroupSummaryRequest) =>
    api.post<EstimationNs.GetGroupSummaryRequest, EstimationNs.GroupSummary[]>('get-group-summary', data),
  getRecipients: (data: EstimationNs.GetRecipientsRequest) =>
    api.post<EstimationNs.GetRecipientsRequest, EstimationNs.Recipient[]>('get-recipients', data),

  // — Project (üst-level) —
  createEstimationSettings: (data: EstimationNs.UpdateEstimationRequest) =>
    api.post<EstimationNs.UpdateEstimationRequest, EstimationNs.ProjectEstimation>('create-project', data),
  updateEstimationSettings: (data: EstimationNs.UpdateEstimationRequest) =>
    api.post<EstimationNs.UpdateEstimationRequest, EstimationNs.ProjectEstimation>('update-project', data),
  deleteEstimation: (data: EstimationNs.DeleteEstimationRequest) =>
    api.post<EstimationNs.DeleteEstimationRequest, void>('delete-project', data),
  updateProjectCurrency: (data: EstimationNs.UpdateProjectCurrencyRequest) =>
    api.post<EstimationNs.UpdateProjectCurrencyRequest, EstimationNs.ProjectEstimation>('update-project-currency', data),

  // — Feature satırı —
  updateFeatureEstimation: (data: EstimationNs.UpdateFeatureEstimationRequest) =>
    api.post<EstimationNs.UpdateFeatureEstimationRequest, EstimationNs.FeatureEstimation>('update-feature', data),
  toggleFeatureHidden: (data: EstimationNs.ToggleFeatureHiddenRequest) =>
    api.post<EstimationNs.ToggleFeatureHiddenRequest, EstimationNs.FeatureEstimation[]>('update-feature-hidden', data),

  // — AI Estimation —
  aiEstimate: (data: EstimationNs.AiEstimateRequest) =>
    api.post<EstimationNs.AiEstimateRequest, EstimationNs.AiEstimateResult[]>('ai-estimate', data),

  discardAiEstimate: (data: EstimationNs.DiscardAiEstimateRequest) =>
    api.post<EstimationNs.DiscardAiEstimateRequest, void>('discard-ai-estimate', data),

  // — Scope-size saat config —
  getEstimationConfig: (data: EstimationNs.GetEstimationConfigRequest) =>
    api.post<EstimationNs.GetEstimationConfigRequest, EstimationNs.EstimationConfig>('config/get', data),
  saveEstimationConfig: (data: EstimationNs.SaveEstimationConfigRequest) =>
    api.post<EstimationNs.SaveEstimationConfigRequest, EstimationNs.EstimationConfig>('config/save', data),

  // — Group —
  createGroup: (data: EstimationNs.UpdateEstimationRequest) =>
    api.post<EstimationNs.UpdateEstimationRequest, EstimationNs.EstimationGroup>('create-group', data),
  updateGroup: (data: EstimationNs.UpdateGroupRequest) =>
    api.post<EstimationNs.UpdateGroupRequest, EstimationNs.EstimationGroup>('update-group', data),
  updateGroupVisibility: (data: EstimationNs.UpdateGroupVisibilityRequest) =>
    api.post<EstimationNs.UpdateGroupVisibilityRequest, EstimationNs.EstimationGroup>('update-group-visibility', data),
  deleteGroup: (data: EstimationNs.DeleteGroupRequest) =>
    api.post<EstimationNs.DeleteGroupRequest, EstimationNs.ProjectEstimation>('delete-group', data),

  // — Send / Recipient —
  sendEstimation: (data: EstimationNs.SendEstimationRequest) =>
    api.post<EstimationNs.SendEstimationRequest, void>('send-estimation', data),
  deleteRecipient: (data: EstimationNs.DeleteRecipientRequest) =>
    api.post<EstimationNs.DeleteRecipientRequest, void>('delete-recipient', data),
}
